/**
 * Las rutas que abre el VENDEDOR de un drop: un miembro del equipo que carga ventas y no administra
 * (founder, 29-sep: «el drop Vital Natura Plus pidió separar la cuenta administradora de la de sus
 * vendedores»).
 *
 * ⭐ ES LA LISTA DEL DROP, RECORTADA. El vendedor vive dentro de una cuenta Drop, así que su lista
 *    es un subconjunto de `RUTAS_DEL_ROL_DROP`: sus ventas —con la venta, su entrega, su pedido al
 *    almacén y sus pagos— y sus clientes. Nada más.
 *
 * 🪤 LO QUE QUEDA AFUERA, Y POR QUÉ:
 *      · el catálogo y la ficha del producto: ahí está el precio mayorista, o sea el costo;
 *      · el Inicio: sus números son los del negocio entero (vendido, cobrado, por cobrar);
 *      · las Novedades: anuncian márgenes («hasta S/ 145 de margen por unidad»);
 *      · la Billetera, la Liquidación, Transporte y los Ajustes: los administra el dueño.
 *    Lo que vea de una venta —precio sí, costo no— lo decide su rol de ventas (`opsCaps`), y lo que
 *    la base le devuelve lo decide la base (20260929150000).
 */
import { matchPath } from 'react-router-dom';
import { ROUTES } from '@/config/routes.config';
import { rutaSinTienda } from './rutasDelRolDrop';

export const RUTAS_DEL_VENDEDOR_DROP: readonly string[] = [
  ROUTES.OPS_VENTAS, ROUTES.OPS_PEDIDOS, ROUTES.OPS_COBRANZAS, ROUTES.OPS_CANCELADAS, ROUTES.OPS_ORDER_NEW,
  ROUTES.OPS_ORDER_DETAIL, ROUTES.OPS_ORDER_ENTREGA, ROUTES.OPS_ORDER_DROP, ROUTES.OPS_ORDER_PAGOS,
  ROUTES.CUSTOMERS, ROUTES.CUSTOMER_DETAIL,
  // Sus notificaciones: la campana la ve, y su pie lleva a la lista entera (20-oct-2026).
  ROUTES.NOTIFICACIONES,
  // Configuración › Integraciones, la de siempre, con sus dos couriers (founder, 26-oct-2026: «respetar los nombres que
  // tenemos: Integraciones, y adentro Shalom y Olva; no crear ni recrear páginas»). Shalom PRO es SU cuenta (22-oct);
  // Olva es la cuenta del negocio: la ve y la usa, no hay cuenta de Olva por vendedor.
  ROUTES.SETTINGS, ROUTES.SETTINGS_INTEGRATIONS, ROUTES.SETTINGS_INTEGRATIONS_SHALOM, ROUTES.SETTINGS_INTEGRATIONS_OLVA,
];

/**
 * Los ítems del menú lateral que ve (claves de `SIDEBAR_MAIN`).
 *
 * ⭐ Y «CONFIGURACIÓN», LA DE SIEMPRE (founder, 23-oct-2026: «ni siquiera tiene Configuración»; 26-oct: «respetar los
 *    nombres que tenemos»). Entra por Integraciones, que es lo primero que le toca (`URLS_DEL_VENDEDOR_DROP`), y el menú
 *    de Configuración le muestra los grupos de siempre recortados a su portón: «Canales y apps › Integraciones».
 */
export const MENU_DEL_VENDEDOR_DROP: readonly string[] = ['operaciones', 'customers', 'settings'];

/** A dónde lleva cada ítem del menú cuando la ruta del ítem no es la suya. */
export const URLS_DEL_VENDEDOR_DROP: Readonly<Record<string, string>> = { settings: ROUTES.SETTINGS_INTEGRATIONS };

/** Las integraciones que ve en Integraciones (ids de `INTEGRATION_PROVIDERS`): sus couriers, nada de canales de venta. */
export const INTEGRACIONES_DEL_VENDEDOR_DROP = ['shalom', 'olva'] as const;

/** A dónde va el vendedor que abre algo que no es suyo, y adonde entra: sus ventas. */
export const A_DONDE_VA_EL_VENDEDOR_DROP = ROUTES.OPS_VENTAS;

export function laRutaEsDelVendedorDrop(pathname: string): boolean {
  const ruta = rutaSinTienda(pathname);
  return RUTAS_DEL_VENDEDOR_DROP.some((patron) => matchPath({ path: patron, end: true }, ruta) !== null);
}
